/* A real dropdown for the model year.

   THE PROBLEM WITH THE NATIVE ONE. The trigger was already styled: the
   extension sets appearance:none, a pill border and a red chevron. What cannot
   be styled is the part the customer actually sees when they tap it. A native
   select's option list is drawn by the operating system, outside the page, so
   no stylesheet reaches it. On macOS it arrives as a blue and grey system menu
   in the middle of a black and red store. The only way to style it is to stop
   using it.

   THE NATIVE SELECT STAYS. It is hidden from sight and from the tab order, but
   it remains in the DOM and it remains the value. Every pick writes to it and
   fires a bubbling change event, so the extension's own handler runs exactly
   as before and nothing downstream knows this happened. Remove this script and
   the select reappears and the page still works.

   THE LIST IS position: fixed, ON PURPOSE. Absolute positioning inside the
   sheet gets clipped by the first ancestor with overflow hidden, and there are
   several. Fixed takes it out of that chain entirely; the trade is that the
   position has to be recomputed on scroll and resize while it is open, which
   is what the listeners below do.

   IT REBUILDS ITSELF. The extension re-renders the sheet, and the year list is
   empty until it does, so the observer watches for a select whose options no
   longer match the control built for it. The signature check means an
   unchanged select is left alone rather than rebuilt on every mutation. */
(function () {
  var SEL = 'select.vin-filter-select';
  var JOIN = ' >> ';
  var open = null;
  var queued = null;
  var seq = 0;

  function chevron() {
    var s = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    s.setAttribute('viewBox', '0 0 12 8');
    s.setAttribute('aria-hidden', 'true');
    s.setAttribute('class', 'fx-sel__chev');
    var p = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    p.setAttribute('d', 'M1 1.5 6 6.5 11 1.5');
    p.setAttribute('fill', 'none');
    p.setAttribute('stroke', 'currentColor');
    p.setAttribute('stroke-width', '1.6');
    p.setAttribute('stroke-linecap', 'round');
    p.setAttribute('stroke-linejoin', 'round');
    s.appendChild(p);
    return s;
  }

  function signature(select) {
    var out = [];
    for (var i = 0; i < select.options.length; i++) out.push(select.options[i].text);
    return out.join(JOIN);
  }

  function place(control) {
    if (!control || !control.list || control.list.hidden) return;
    var r = control.btn.getBoundingClientRect();
    var room = window.innerHeight - r.bottom - 12;
    var above = r.top - 12;
    var drop = room >= 200 || room >= above;
    control.list.style.left = Math.round(r.left) + 'px';
    control.list.style.width = Math.round(r.width) + 'px';
    if (drop) {
      control.list.style.top = Math.round(r.bottom + 8) + 'px';
      control.list.style.bottom = 'auto';
      control.list.style.maxHeight = Math.max(140, Math.round(room)) + 'px';
    } else {
      control.list.style.top = 'auto';
      control.list.style.bottom = Math.round(window.innerHeight - r.top + 8) + 'px';
      control.list.style.maxHeight = Math.max(140, Math.round(above)) + 'px';
    }
  }

  function close(control) {
    if (!control || control.list.hidden) return;
    control.list.hidden = true;
    control.btn.setAttribute('aria-expanded', 'false');
    control.field.classList.remove('fx-sel-open');
    if (open === control) open = null;
  }

  function closeAll() { if (open) close(open); }

  function show(control) {
    closeAll();
    control.list.hidden = false;
    control.btn.setAttribute('aria-expanded', 'true');
    control.field.classList.add('fx-sel-open');
    open = control;
    place(control);
    var on = control.list.querySelector('[aria-selected="true"]');
    if (on) on.scrollIntoView({ block: 'nearest' });
  }

  function label(control) {
    var s = control.select;
    var o = s.options[s.selectedIndex];
    control.val.textContent = o ? o.text : '';
    control.field.classList.toggle('fx-sel-placeholder', s.selectedIndex <= 0);
  }

  function mark(control) {
    var opts = control.list.children;
    for (var i = 0; i < opts.length; i++) {
      opts[i].setAttribute('aria-selected', i === control.select.selectedIndex ? 'true' : 'false');
    }
  }

  function choose(control, index) {
    if (control.select.selectedIndex !== index) {
      control.select.selectedIndex = index;
      control.select.dispatchEvent(new Event('input', { bubbles: true }));
      control.select.dispatchEvent(new Event('change', { bubbles: true }));
    }
    mark(control);
    label(control);
    close(control);
    control.btn.focus();
  }

  function move(control, step) {
    var n = control.select.options.length;
    var next = control.select.selectedIndex;
    for (var k = 0; k < n; k++) {
      next = next + step;
      if (next < 0 || next >= n) return;
      if (!control.select.options[next].disabled) break;
    }
    choose(control, next);
  }

  function build(select) {
    var field = select.parentElement;
    if (!field) return;

    /* The list lives on body, not in the field, so removing the control is not
       enough: the old list has to go with it or every rebuild leaves an
       orphan behind and the next query finds a stale one. */
    var old = field.querySelector('.fx-sel');
    if (old) old.remove();
    var oldId = field.getAttribute('data-fx-list');
    if (oldId) {
      var orphan = document.getElementById(oldId);
      if (orphan) orphan.remove();
    }

    var control = { select: select, field: field };

    var wrap = document.createElement('div');
    wrap.className = 'fx-sel';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'fx-sel__btn';
    btn.setAttribute('aria-haspopup', 'listbox');
    btn.setAttribute('aria-expanded', 'false');

    var val = document.createElement('span');
    val.className = 'fx-sel__val';
    btn.appendChild(val);
    btn.appendChild(chevron());

    var list = document.createElement('ul');
    list.className = 'fx-sel__list';
    list.setAttribute('role', 'listbox');
    list.hidden = true;
    list.id = 'fx-sel-list-' + (++seq);
    btn.setAttribute('aria-controls', list.id);
    field.setAttribute('data-fx-list', list.id);

    for (var i = 0; i < select.options.length; i++) {
      var o = select.options[i];
      var li = document.createElement('li');
      li.className = 'fx-sel__opt';
      li.setAttribute('role', 'option');
      li.textContent = o.text;
      if (o.disabled) li.setAttribute('aria-disabled', 'true');
      (function (idx, disabled) {
        li.addEventListener('click', function () {
          if (disabled) return;
          choose(control, idx);
        });
      })(i, o.disabled);
      list.appendChild(li);
    }

    control.btn = btn;
    control.val = val;
    control.list = list;

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (list.hidden) show(control); else close(control);
    });

    btn.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); if (list.hidden) show(control); else move(control, 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); if (list.hidden) show(control); else move(control, -1); }
      else if (e.key === 'Escape') { close(control); }
      else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); if (list.hidden) show(control); else close(control); }
    });

    /* The extension sets the value itself when the sheet remembers a pick. */
    select.addEventListener('change', function () { mark(control); label(control); });

    select.setAttribute('tabindex', '-1');
    select.setAttribute('aria-hidden', 'true');
    field.classList.add('fx-sel-host');
    field.setAttribute('data-fx-sel', signature(select));

    wrap.appendChild(btn);
    document.body.appendChild(list);
    field.appendChild(wrap);

    mark(control);
    label(control);
  }

  function pass() {
    queued = null;
    var all = document.querySelectorAll(SEL);
    for (var i = 0; i < all.length; i++) {
      var s = all[i];
      var field = s.parentElement;
      if (!field) continue;
      if (field.getAttribute('data-fx-sel') === signature(s) && field.querySelector('.fx-sel')) continue;
      build(s);
    }
  }

  function schedule() {
    if (queued) return;
    queued = window.setTimeout(pass, 60);
  }

  function boot() {
    pass();

    document.addEventListener('click', function (e) {
      if (!open) return;
      if (open.list.contains(e.target) || open.btn.contains(e.target)) return;
      closeAll();
    }, true);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll();
    });

    window.addEventListener('scroll', function () { place(open); }, true);
    window.addEventListener('resize', function () { closeAll(); });

    if (!window.MutationObserver) return;
    new window.MutationObserver(schedule).observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
